<div class="product-selection mt-3">
  <ng-container *appLoad="let products of load$">
    <!-- list of options -->
    <div class="product-selection__list">
      <div class="options" *ngIf="products?.length; else tplNoResults">
        <div
          id="shortlist-option-{{ idx }}"
          *ngFor="let product of products; let idx = index">
          <lds-card
            [isClickable]="true"
            (click)="router.navigate(['Opportunities', product.opportunityId])">
            <div *ngFor="let split of product.splits">
              <!-- option details -->
              <div class="row">
                <div class="col-auto">
                  <div class="option__logo text-center">
                    <app-provider-image [providerName]="split.providerName">
                    </app-provider-image>
                  </div>
                </div>
                <div class="col">
                  <div class="row option__focus mr-3">
                    <div class="col-3 align-self-center">
                      <span class="option__name">{{ split.productName }}</span>
                    </div>

                    <div class="col-2">
                      <ng-container
                        *ngIf="product.isInsuranceProduct; else settledLabel">
                        <div class="option__label">issued</div>
                      </ng-container>
                      <div class="option__text">
                        {{ product.settlementDate | date : 'dd/MM/yyyy' }}
                      </div>
                    </div>

                    <div class="col-2">
                      <div class="option__label">amount</div>
                      <div class="option__text">
                        {{
                          split.splitAmount
                            | currency : '' : 'symbol-narrow' : '1.0-0'
                        }}
                      </div>
                    </div>
                    <ng-container *ngIf="split.structure">
                      <div class="col-3 p-0">
                        <div class="option__label">rate / term / type</div>
                        <ng-container *ngIf="split.structure.singleTerm">
                          <div class="option__text">
                            {{
                              split.structure.singleTerm.rate | percent : '1.2'
                            }}
                            <span class="info-divider"></span>
                            {{
                              split.structure.singleTerm.term
                                | formatLoanTerm : true
                            }}
                            <span class="info-divider"></span>
                            {{ split.structure.singleTerm.rateType }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="split.structure.multiTerm">
                          <div class="option__text">
                            {{
                              split.structure.multiTerm.initialTerm.rate
                                | percent : '1.2'
                            }}
                            <span class="info-divider"></span>
                            {{
                              split.structure.multiTerm.initialTerm.term
                                | formatLoanTerm : true
                            }}
                            <span class="info-divider"></span>
                            {{ split.structure.multiTerm.initialTerm.rateType }}
                          </div>
                          <div class="option__text">
                            {{
                              split.structure.multiTerm.revertTerm.rate
                                | percent : '1.2'
                            }}
                            <span class="info-divider"></span>
                            {{
                              split.structure.multiTerm.revertTerm.term
                                | formatLoanTerm : true
                            }}
                            <span class="info-divider"></span>
                            {{ split.structure.multiTerm.revertTerm.rateType }}
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="split.frequency">
                      <div class="col-2">
                        <ng-container
                          [ngTemplateOutlet]="
                            product.isInsuranceProduct
                              ? premiumLabel
                              : repaymentsLabel
                          "
                          [ngTemplateOutletContext]="{ split: split }">
                        </ng-container>
                        <div class="option__text">
                          {{
                            split.repaymentAmount
                              | currency : '' : 'symbol-narrow' : '1.0-0'
                          }}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </lds-card>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #repaymentsLabel let-split="split">
  <div class="option__label">{{ split.frequency }} repayments</div>
</ng-template>

<ng-template #premiumLabel let-split="split">
  <div class="option__label">{{ split.frequency }} premium</div>
</ng-template>

<ng-template #settledLabel>
  <div class="option__label">settled</div>
</ng-template>

<!-- template / no results -->
<ng-template #tplNoResults>
  <lds-empty-state heading="No products available"
                   message="No settled products found for this contact.">
  </lds-empty-state>
</ng-template>

